import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { RdsField } from './CreateRdsExtension';

export const CreateRdsExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'RdsField',
    component: RdsField,
  }),
);
